import React from 'react'
import Updatepersonstatus from '../../Services/Mutations/updatepersonstatus'
import { toast } from 'react-toastify'
import Updateperson from '../../Services/Mutations/Updateperson'
import { useState } from 'react'
import PersonFilter from '../../Services/Queries/personfilter'
import Personlist from '../../Services/Queries/personlist'
import { useEffect } from 'react'
import { filterAndResetButton } from '../Data/PersonStaticData'

import ListPersonsactions from './ListPersonsactions'
import { GetPersonStatus } from './GetPersonStatus'
toast.configure()

export default function ListPersons(props) {
  const {
    setpersonsLIst,
    personsLIst,
    isPopSelected,
    editFieldName,
    handleCancelClick,
    okButtonDisabled,
    sendPop,
    checkedArray,
    sendPersonsData,
    sendCheckedArray,
    editValue,
    pkValue,
    sendOkButtonDisable,
    ApproveOptionPermission,
    EDitOptionPermission,
    DeleteOptionPermission,
    BulkActionPermission,
  } = props
  const [selectedBulkActionStatus, setselectedBulkActionStatus] = useState()
  const [displayLoadMore, setDisplayLoadMore] = useState()
  const [searchListTrue, setSearchListTrue] = useState(false)
  const [DesableFilter, setDesableFilter] = useState(true)
  const [loadSpinner, setLoadSpinner] = useState(false)
  const [selectedPersonType, setSelectedPersonType] = useState('person')
  const [selectedStatus, setSelectedStatus] = useState('published')
  const [selectedFilterOptions, setSelectedFilterOptions] = useState([])
  const [searchQuery, setSearchQuery] = useState('')
  const [isDataFiltered, setDataFiltered] = useState(false)
  const [nextToken, setNextToken] = useState(null)
  const [selectedPopular, setSelectedPopular] = useState('')
  const [SelectedActiveorNot, setSelectedActiveorNot] = useState('')
  const [tags, setTags] = useState({})
  const [GOAT, setGOAT] = useState('')
  const [from, setFrom] = useState(0)
  const limit = 10
// console.log(tags, 'tags===')
  const updateAndToast = (input, name) => {
    Updateperson(input)
    toast.success(`${[editFieldName]} of ${name} updated`)
  }

  const getPersonInput = input => {
    const { personList, editFieldName, pkValue, editedValues } = input

    const personListTemp = personList.map(e => {
      if (e.PK === pkValue) {
        const updatedPerson = {
          PK: e.PK,
          SK: e.SK,
          [editFieldName]: editedValues,
        }

        e[`${editFieldName}`] = editedValues
        const occupationV2Key = `${editFieldName}V2`

        if (editFieldName === 'occupation_En' || editFieldName === 'occupation_Te') {
          const occupationV2 = editedValues.split(',')
          updatedPerson[occupationV2Key] = occupationV2
        }

        updateAndToast(updatedPerson, e.name_En)
        return e
      }

      return e
    })

    setpersonsLIst(personListTemp)
  }

  const handleSaveClick = () => {
    const personList = [...personsLIst]

    if (editFieldName === 'dateOfBirth') {
      const [YYYY, MM, DD] = (editValue || '0000-00-00').split('-')
      const editedSpecficValue = `${YYYY}${MM}${DD || '00'}`
      const DDMM = `${MM || '00'}${DD || '00'}`

      personList.forEach(e => {
        if (e.PK === pkValue) {
          e[editFieldName] = editedSpecficValue
          const input = { PK: e.PK, SK: e.SK, [editFieldName]: editedSpecficValue, birthdayMonthAndDate: DDMM, birthYear: YYYY }
          updateAndToast(input, e.name_En)
        }
      })
    } else if (['roles', 'occupation_En', 'occupation_Te'].includes(editFieldName)) {
      const editedValues = (editFieldName === 'roles') ? editValue.split(',') : editValue.map(e => e.label).toString()
      const input = { personList, editFieldName, pkValue, editedValues }
      getPersonInput(input)
    } else {
      const input = { personList, editFieldName, pkValue, editedValues: editValue }
      getPersonInput(input)
    }

    sendOkButtonDisable(false)
    sendPersonsData(personList)
    sendPop(!isPopSelected)
  }

  const applyFunction = async () => {
    const personDataArray = personsLIst.filter(e => !e.isAdded)
    sendPersonsData(personDataArray)
    try {
        const statusAndMessageResponse = await GetPersonStatus(selectedBulkActionStatus)
        const { status } = statusAndMessageResponse

        await Promise.all(checkedArray.map(async person => {
          await updatePersonStatusAndNotify(person, status)
        }))
    } catch (error) {
        console.error('Error:', error)
    }

    sendCheckedArray([])
}

  const updatePersonStatusAndNotify = async (person, status) => {
    const { statusCode, statusMessage } = await Updatepersonstatus({ PK: person.PK, SK: person.SK, status })
    if (statusCode === 'A368') {
      toast.success(`${statusMessage} ${person.PK}`)
    }
  }

  const handlePersonAction = (person, status) => {
    const personList = [...personsLIst]
    const PersonsTemp = personList.filter(personlist => personlist.PK !== person.PK)
    updatePersonStatusAndNotify(person, status)
    sendPersonsData(PersonsTemp)
  }

  const deleteFunction = item => handlePersonAction(item, 'deleted')

  const approvePerson = item => handlePersonAction(item, 'published')

  const handlePersonType = e => {
    setSearchListTrue(false)
    setSelectedPersonType(e.target.value)
    setDesableFilter(false)
  }

  const handlePersonPopularActive = (e, value) => {
    setSearchListTrue(false)
    setDesableFilter(false)
    if (value === 'popular') {
    setSelectedPopular(e.target.value)
    } else if (value === 'GOAT') {
      setGOAT(e.target.value)
    } else {
    setSelectedActiveorNot(e.target.value)
    }
  }

  const handleFilterOptions = selectedOptions => {
    setSearchListTrue(false)
    setSelectedFilterOptions(selectedOptions)
    setDesableFilter(false)
  }

  const handlePersonStatus = e => {
    setSelectedStatus(e.target.value)
    handleReset(e.target.value)
  }

  const handleFilter = async isNextSet => {
    setLoadSpinner(true)
    setSearchListTrue(false)

    const filterOptionsObject = selectedFilterOptions.reduce((options, { value }) => {
      options[value] = 'none'
      return options
    }, {})

    if (selectedPopular) {
filterOptionsObject.popularPerson = selectedPopular
}

    if (SelectedActiveorNot) {
filterOptionsObject.currentlyActive = SelectedActiveorNot
}

if (GOAT) {
  filterOptionsObject.GOAT = GOAT
}

    const filterInput = {
      search: searchQuery,
      personFilterBy: selectedPersonType ? { ...filterOptionsObject, ...tags, personType: selectedPersonType } : { ...filterOptionsObject, ...tags },
      type: 'person',
      from: isNextSet ? from + limit : 0,
      limit,
    }

    try {
      const filterResponse = await PersonFilter(filterInput)

      setDataFiltered(true)
      setFrom(filterInput.from)
      const finalPersonList = isNextSet ? [...personsLIst, ...filterResponse.items] : filterResponse ? [...filterResponse.items] : []
      setpersonsLIst(finalPersonList)
      setDisplayLoadMore(filterResponse && filterResponse.total ? finalPersonList.length !== filterResponse.total : false)
    } catch (error) {
      console.error('Error in handleFilter:', error)
      setpersonsLIst([])
    }

    setLoadSpinner(false)
  }

  const handleReset = async status => {
    setSearchListTrue(false)
    setDesableFilter(true)
    setSelectedPersonType('person')
    setSelectedStatus(status ? status : 'published')
    setSelectedFilterOptions([])
    setSearchQuery('')
    setDataFiltered(false)
    setSelectedPopular('')
    setSelectedActiveorNot('')
    setGOAT('')
    setFrom(0)
    setTags({})
    await GetPersonList(status ? status : 'published')
  }

  const handleLoadMore = async isNextSet => {
    setLoadSpinner(true)
    if (isDataFiltered) {
      handleFilter(isNextSet)
    } else {
      const personListInput = { status: selectedStatus, limit, nextToken }
      try {
        const personsListResponse = await Personlist(personListInput)
        const finalPersonList = isNextSet
          ? [...personsLIst, ...personsListResponse.items]
          : [...personsListResponse.items]
        setpersonsLIst(finalPersonList)
        setNextToken(
          personsListResponse && personsListResponse.nextToken
            ? personsListResponse.nextToken
            : null,
          setDisplayLoadMore(personsListResponse.nextToken !== null),
        )
      } catch {
        setpersonsLIst([])
        setNextToken(null)
      }
    }

    setLoadSpinner(false)
  }

  const GetPersonList = async Status => {
    const personListInput = { status: Status, limit }
    setLoadSpinner(true)
    try {
      const persons = await Personlist(personListInput)
      setpersonsLIst(persons && persons.items ? persons.items : [])
      setNextToken(persons && persons.nextToken ? persons.nextToken : null)
      setDisplayLoadMore(persons.nextToken !== null)
    } catch {
      setpersonsLIst([])
      setNextToken(null)
    }

    setLoadSpinner(false)
  }

  useEffect(() => {
    const getPersonsList = async () => {
      await GetPersonList('published')
    }

    getPersonsList()
  }, [])

  return (
    <ListPersonsactions
      EDitOptionPermission={EDitOptionPermission}
      DeleteOptionPermission={DeleteOptionPermission}
      BulkActionPermission={BulkActionPermission}
      setLoadSpinner={setLoadSpinner}
      setSearchQuery={setSearchQuery}
      setDesableFilter={setDesableFilter}
      setSearchListTrue={setSearchListTrue}
      loadSpinner={loadSpinner}
      handlePersonStatus={handlePersonStatus}
      handleReset={handleReset}
      selectedStatus={selectedStatus}
      filterAndResetButton={filterAndResetButton}
      DesableFilter={DesableFilter}
      searchQuery={searchQuery}
      searchListTrue={searchListTrue}
      handleFilter={handleFilter}
      handlePersonType={handlePersonType}
      selectedPersonType={selectedPersonType}
      selectedFilterOptions={selectedFilterOptions}
      handleFilterOptions={handleFilterOptions}
      isPopSelected={isPopSelected}
      editFieldName={editFieldName}
      handleLoadMore={handleLoadMore}
      displayLoadMore={displayLoadMore}
      inputmodel={props.inputmodel}
      handleCancelClick={handleCancelClick}
      handleSaveClick={handleSaveClick}
      okButtonDisabled={okButtonDisabled}
      sendPop={sendPop}
      personsLIst={personsLIst}
      deleteFunction={deleteFunction}
      onAddingItem={props.onAddingItem}
      editFunction={props.editFunction}
      applyFunction={applyFunction}
      checkedArray={checkedArray}
      setselectedBulkActionStatus={setselectedBulkActionStatus}
      selectedPopular={selectedPopular}
      setSelectedPopular={setSelectedPopular}
      handlePersonPopularActive={handlePersonPopularActive}
      SelectedActiveorNot={SelectedActiveorNot}
      approvePerson={approvePerson}
      GOAT={GOAT}
      ApproveOptionPermission={ApproveOptionPermission}
      tags={tags}
      setTags={setTags}
    />
  )
}
